import { render, staticRenderFns } from "./CompanySPCertificationForm.vue?vue&type=template&id=6173b8c6"
import script from "./CompanySPCertificationForm.vue?vue&type=script&lang=js"
export * from "./CompanySPCertificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports